module.exports = __webpack_public_path__ + "img/Role.507d6307.svg";